import styled from '@emotion/styled';
import { colors, fonts, radii, breakpoints, CheckIcon } from '../../../ui';

// Near Vision (ICN) scoring list (Figma session/15 left, 24 left): one row per print size of the
// current group - "n104" above the text box, a check box on the left. Only one size can be ticked
// (the smallest line the patient read).

const List = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
  padding: 2px;
  box-sizing: border-box;
  font-family: ${fonts.family};
`;

const Line = styled.label`
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  column-gap: 16px;
  align-items: center;
  cursor: pointer;
  .key {
    grid-column: 2;
    font-size: 12px;
    font-weight: 700;
    color: ${colors.slate[600]};
    margin-bottom: 4px;
  }
  input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }
  .box {
    grid-row: 2;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 1.5px solid ${colors.slate[300]};
    background: #fff;
    color: #fff;
  }
  input:checked ~ .box {
    background: ${colors.teal};
    border-color: ${colors.teal};
  }
  input:focus-visible ~ .box {
    outline: 2px solid ${colors.brand[300]};
    outline-offset: 2px;
  }
  .text {
    grid-row: 2;
    min-height: 44px;
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border: 1px solid ${colors.slate[200]};
    border-radius: ${radii.input}px;
    background: #fff;
    font-size: 14px;
    line-height: 1.5;
    font-weight: 600;
    color: ${colors.slate[800]};
  }
  &[data-checked='true'] .text {
    border-color: ${colors.teal};
  }
  @media (max-width: ${breakpoints.phone - 1}px) {
    column-gap: 10px;
    .text {
      font-size: 13px;
    }
  }
`;

/**
 * @param lines     optimaChartData group fontSizes [{ key: 'n104', content }]
 * @param selected  ticked key
 * @param onSelect  (key) => void
 */
export const NearVisionLines = ({ lines, selected, onSelect }) => (
  <List role='radiogroup' aria-label='Smallest print read'>
    {lines.map((line) => {
      const checked = line.key === selected;
      return (
        <Line key={line.key} data-checked={checked} style={{ position: 'relative' }}>
          <span className='key'>{line.key}</span>
          <input type='radio' name='near-vision-line' value={line.key} checked={checked} onChange={() => onSelect(line.key)} />
          <span className='box' aria-hidden='true'>
            {checked && <CheckIcon size={14} strokeWidth={3} />}
          </span>
          <span className='text'>{line.content}</span>
        </Line>
      );
    })}
  </List>
);

export default NearVisionLines;
